'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.controller("ticketAnnulerDemandeReouverturePopinController", function ($scope, $http, $q, lovService, $notifications) {
  var ticket = $scope.ticket;
  $scope.params = {
    ticketId: $scope.ticket.id,
    demande: null
  };
  $scope.annuler = function () {
    if ($scope.loading) return;
    $scope.loading = true;
    $http.post('/rest/echange/ticket-client/annuler-demande-reouverture/' + $scope.params.ticketId, null, {
      params: $scope.params
    }).then(function () {
      $notifications.info("Annulation de la demande prise en compte");
      $scope.$close();
    }).finally(function () {
      $scope.loading = false;
    });
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ticket/annulerDemandeReouverture/ticketAnnulerDemandeReouverturePopinController.js
// module id = 2886
// module chunks = 13